import * as React from 'react'
import * as css from './AreasServed.module.css'
import SanityBlock from 'components/common/SanityBlock'
import Img from 'components/common/Img'
import clsx from 'clsx'

const AreasServed = ({ title, description, _rawContent, areas, image }) => (
  <section className="bg-suede-black text-white padding">
    <div className="grid md:grid-cols-2 gap-8 items-center ctnr">
      <div className="mx-auto">
        <div className="richtext">
          <h2 className="h1">{title}</h2>
          {description && (
            <p className="max-w-[450px]">{description}</p>
          )}

          <SanityBlock
            body={_rawContent}
            components={{
              list: ({ type, children }) => {
                switch(type) {
                  case 'bullet': return <ul className={css.bullets}>{children}</ul>
                  case 'number': return <ol className={css.numbered}>{children}</ol>
                  default: return null
                }
              },
            }}
          />
        </div>

        <ol className={clsx(css.list, 'max-w-[450px]')}>
          {areas?.map((item, key) => (
            <li key={key}>{item}</li>
          ))}
        </ol>
      </div>

      <Img
        className="max-w-[450px] mx-auto"
        image={image?.image}
      />
    </div>
  </section>
)

export default AreasServed
